/**
 * VpcMairieIcon — icône officielle Vision Pro Collectivité (bâtiment mairie :
 * fronton + 4 colonnes + marches + étoile + drapeau). S'utilise comme une icône
 * lucide-react (props SVG standard, `className` pour la taille/couleur).
 *
 * Dessinée en currentColor pour s'intégrer au LogoMark (carré gradient + glow) :
 * passée à <LogoMark icon={VpcMairieIcon} />, elle s'affiche en blanc sur le
 * gradient, comme les icônes lucide actuelles.
 */
import type { SVGProps } from 'react';

export function VpcMairieIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      {/* drapeau au sommet */}
      <path d="M12 3.4V2" />
      <path d="M12 2.2h1.7v1.1H12" fill="currentColor" stroke="none" />
      {/* fronton triangulaire */}
      <path d="M3.5 8.5 12 3.6l8.5 4.9Z" />
      {/* étoile au centre du fronton */}
      <path d="M12 5.4l.5 1.1 1.2.1-.9.8.3 1.2-1.1-.7-1.1.7.3-1.2-.9-.8 1.2-.1Z" fill="currentColor" stroke="none" />
      {/* architrave */}
      <path d="M3.7 9.2h16.6" />
      {/* 4 colonnes */}
      <path d="M5.6 9.6v8.2M9.5 9.6v8.2M14.5 9.6v8.2M18.4 9.6v8.2" />
      {/* marches / base */}
      <path d="M4.3 17.9h15.4" />
      <path d="M3 20.4h18" />
    </svg>
  );
}
